import { render, staticRenderFns } from "./98.vue?vue&type=template&id=5e798c2f&scoped=true&"
var script = {}
import style0 from "./98.vue?vue&type=style&index=0&id=5e798c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e798c2f",
  null
  
)

export default component.exports